import * as tslib_1 from "tslib";
import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '../../../core';
var FormlyWrapperValidationMessages = (function (_super) {
    tslib_1.__extends(FormlyWrapperValidationMessages, _super);
    function FormlyWrapperValidationMessages() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FormlyWrapperValidationMessages.prototype, "validationId", {
        get: function () {
            return this.field.id + '-message';
        },
        enumerable: true,
        configurable: true
    });
    return FormlyWrapperValidationMessages;
}(FieldWrapper));
tslib_1.__decorate([
    ViewChild('fieldComponent', { read: ViewContainerRef }),
    tslib_1.__metadata("design:type", ViewContainerRef)
], FormlyWrapperValidationMessages.prototype, "fieldComponent", void 0);
FormlyWrapperValidationMessages = tslib_1.__decorate([
    Component({
        selector: 'formly-wrapper-validation-messages',
        template: "\n    <ng-container #fieldComponent></ng-container>\n    <div>\n      <small class=\"text-muted text-danger\" *ngIf=\"showError\" role=\"alert\" [id]=\"validationId\"><formly-validation-message [fieldForm]=\"formControl\" [field]=\"field\"></formly-validation-message></small>\n    </div>\n  ",
    })
], FormlyWrapperValidationMessages);
export { FormlyWrapperValidationMessages };
//# sourceMappingURL=message-validation.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/wrappers/message-validation.js
// module id = 785
// module chunks = 3